/** Formata centavos como "R$ 1.234,56". */
export function formatBRL(cents: number): string {
  if (!Number.isInteger(cents)) throw new Error("cents must be an integer");
  const sign = cents < 0 ? "-" : "";
  const abs = Math.abs(cents);
  const reais = Math.floor(abs / 100)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  const rest = (abs % 100).toString().padStart(2, "0");
  return `${sign}R$ ${reais},${rest}`;
}

/** Centavos para o valor decimal usado pela Asaas (99.99). */
export function centsToDecimal(cents: number): number {
  return Math.round(cents) / 100;
}

export function decimalToCents(value: number): number {
  return Math.round(value * 100);
}

/** Pontos-base: 5000 = 50%. */
export function applyBps(cents: number, bps: number): number {
  return Math.floor((cents * bps) / 10_000);
}
